import Http, {paramsSerializer} from "../config/axios.js"
import {to} from "await-to-js"

export default {
    async list(params) {
        return to(Http.get(window.API_PREFIX + "/providers", {params, paramsSerializer}))
    },
    async get(id) {
        return to(Http.get(window.API_PREFIX + `/providers/${id}`))
    },
    async getSelect(params = {}) {
        return this.list({_type: "select", ...params})
    },
    async create(data) {
        return to(Http.post(window.API_PREFIX + `/providers`, data))
    },
    async insert(data) {
        return to(Http.post(window.API_PREFIX + `/providers`, data))
    },
    async update(id, data) {
        data.append('_method', 'patch')
        return to(Http.post(window.API_PREFIX + `/providers/${id}`, data))
    },
    async save(data, id) {
        return id ? this.update(id, data) : this.insert(data)
    },
    async delete(id) {
        return to(Http.post(window.API_PREFIX + `/providers/${id}`, {'_method': 'delete'}))
    },
    async loadConfig(id, key = null) {
        return to(Http(window.API_PREFIX + `/provider-configs/${id}/${key}`))
    },
    async saveConfig(id, key, config) {
        return to(Http.post(window.API_PREFIX + `/provider-configs/${id}/${key}`, config))
    },
    async loadAddress(id){
        return to(Http.get(window.API_PREFIX + `/provider-address/${id}`))
    },
    async summary(id) {
        return to(Http.get(window.API_PREFIX + `/providers/${id}/summary`))
    },
    async serviceTable(id){
        return to(Http.get(window.API_PREFIX + `/providers/${id}/service-table`))
    },
}

